import { Route } from "react-router-dom";
import Protected from "../../auth/Protected";
import { UserRole } from "../../../enums";
import AdminProfilePage from "./index";
 

export default (
  <Route
    path="profile"
    element={
      <Protected
        path="/admin/profile"
        roles={[UserRole.ADMIN, UserRole.SUPERADMIN]}
      >
        <AdminProfilePage />
      </Protected>
    }
  />
);



